/*
  This file is generated from build-scripts/postinstall-scripts/app-config/environmentMapper.ts
  To keep the build system neat and consistent, we are copying this file to the libs/utils/lib/environmentMapper.ts during postinstall
  If you'd like to update this file, please do so in build-scripts/postinstall-scripts/app-config/environmentMapper.ts
  Then, re-run the postinstall script by running `pnpm install` in the root directory
*/
export type AWS_REGION = 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2';

export const DC4_LANES = [
  'localhost',
  'd1',   // dev
  'q1',   // qa
  'q2',   // qa
  'i1',   // int
  'pl1',  // peg
  's1',   // stg
  'u1',   // uat
  'pr1',  // prod
] as const;

// Legacy (non-DC4) lanes are retained in the TYPE ONLY so release-base consumers
// that still reference them keep type-checking (e.g. libs/auth/lib/refresh.ts:
// `laneTag !== 'p1'`, and the EnvNotificationHeader components). DC4 runtime only
// ever uses DC4_LANES; a legacy lane is never provisioned here and would hit
// getEnvByLane's `default` throw. This makes the DC4 LaneTag additive
// (DC4 ∪ legacy) rather than a narrowing that breaks the release base.
export type LegacyLaneTag = 'd2' | 'st1' | 'pe1' | 'p1';
export type LaneTag = (typeof DC4_LANES)[number] | LegacyLaneTag;

export type EppsEnv =
  | 'dev'
  | 'qa'
  | 'int'
  | 'peg'
  | 'stg'
  | 'uat'
  | 'prod';

export const getEnvByLane = (lane: LaneTag): EppsEnv => {
  switch (lane) {
    case 'localhost':
    case 'd1':       return 'dev';
    case 'q1':
    case 'q2':       return 'qa';
    case 'i1':       return 'int';
    case 'pl1':      return 'peg';
    case 's1':       return 'stg';
    case 'u1':       return 'uat';
    case 'pr1':      return 'prod';
    default:
      throw new Error(`getEnvByLane(${lane}) is not supported`);
  }
};

// d1 → us-east-1, pr1 → us-east-2 regardless of caller's AWS_REGION env var.
// Local postinstall runs without AWS_REGION set fall back to the caller value
// for unpinned lanes (see DC4 build.Jenkinsfile, which exports AWS_REGION).
const LANE_PINNED_REGION: Partial<Record<LaneTag, AWS_REGION>> = {
  d1: 'us-east-1',
  q1: 'us-east-1',
  i1: 'us-east-1',
  pl1: 'us-east-1',
  s1: 'us-east-1',
  u1: 'us-east-1',
  pr1: 'us-east-2', // todo: dr is also pr1
};

export const pinnedRegion = (
  lane: LaneTag,
  fallback: AWS_REGION,
): AWS_REGION => LANE_PINNED_REGION[lane] ?? fallback;
